exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.uk-rounded {\n    border-radius: 5px;\n}\n\n", ""]);

// exports
